import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import AllItems from "../components/Views/AllItems.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import Container from "./Container.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import SettingsIcon from "@material-ui/icons/Settings";

import ConfigurationsContainer from "./ConfigurationsContainer.jsx";
import RoomQuotasContainer from "./RoomQuotasContainer.jsx";
import RoomTypesContainer from "./RoomTypesContainer.jsx";
import RatesContainer from "./RatesContainer.jsx";
import RoomRatesContainer from "./RoomRatesContainer.jsx";
import ReservationsContainer from "./ReservationsContainer.jsx";
import ReservationsASUContainer from "./ReservationsASUContainer.jsx";
import UsersContainer from "./UsersContainer.jsx";
import PaymentMethodsContainer from "./PaymentMethodsContainer.jsx";
import InterfaceTypesContainer from "./InterfaceTypesContainer.jsx";
import InterfacesContainer from "./InterfacesContainer.jsx";
import MarketGroupContainer from "./MarketGroupContainer.jsx";
import MarketCodesContainer from "./MarketCodesContainer.jsx";
import MessageLogsContainer from "./MessageLogsContainer.jsx";
import CancellationPolicyContainer from "./CancellationPolicyContainer.jsx";
import RefundContainer from "./RefundContainer.jsx";
import ServiceCategoriesContainer from "./ServiceCategoriesContainer.jsx";
import ServicesContainer from "./ServicesContainer.jsx";
import RoomFeatureCategoriesContainer from "./RoomFeatureCategoriesContainer.jsx";
import RoomFeaturesContainer from "./RoomFeaturesContainer.jsx";
import BanArrivalsContainer from "./BanArrivalsContainer.jsx";
import PromoContainer from "./PromoContainer.jsx";
import OfficialContainer from "./OfficialContainer.jsx";
import PeriodResidenceContainer from "./PeriodResidenceContainer.jsx";
import PriceExplanationContainer from "./PriceExplanationContainer.jsx";
import PurchasedServicesContainer from "./PurchasedServicesContainer.jsx";
import SubscriptionContainer from "./SubscriptionContainer.jsx";
import PricePeriodsContainer from "./PricePeriodsContainer.jsx";
import VectorPricesContainer from "./VectorPricesContainer.jsx";
import { cancellation_policy } from "../datasource/schema";

class HotelsContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("hotels");
    }

    componentDidMount() {
        if (this.props.setHotelChanged) {
            this.props.setHotelChanged(false);
        }
    }

    updateImage = (propName, imgFile) => {
        const reader = new FileReader();
        reader.readAsDataURL(imgFile);

        reader.onload = () => {
            imgFile &&
                this.setState((prevState) => ({
                    currentItem: {
                        ...prevState.currentItem,
                        // [propName]: reader.result,
                        [propName]: {
                            base64str: reader.result,
                            imageName: imgFile.name,
                        },
                    },
                }));
        };
    };

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();

        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;
        const listButtons = [
            {
                header: "Конфигурация",
                icon: <SettingsIcon />,
                caption: "",
                link: (id) => this.getBoundLink(id, "configurations"),
            },
        ];

        const userType = this.props.user.type;
        const thisManteraExport = userType === "manager_export";
        let userTypeRoutes;

        const viewAndEditFormRoutes = [
            <Route path={routes.view(":id")} exact key="view">
                <ViewForm
                    title="Просмотр отеля"
                    loading={this.state.loading}
                    fields={fields}
                    initAction={this.getItem}
                    item={this.state.currentItem}
                    getBackLink={this.getBackLink}
                    getHotelUsersLink={this.getHotelUsersLink}
                    relations={userType === "admin" ? relations : null}
                    relationsDataSource={
                        userType === "admin" ? relationsDataSource : null
                    }
                />
            </Route>,
            <Route path={routes.edit(":id")} exact key="edit">
                <EditForm
                    loading={this.state.loading}
                    item={this.state.currentItem}
                    fields={fields}
                    errorFields={this.state.error}
                    initAction={this.getItem}
                    submitAction={this.updateItem}
                    submitActionApply={this.updateItemWithoutReload}
                    getBackLink={this.getBackLink}
                    fieldUpdateHandler={this.setFieldValue}
                    updateImage={this.updateImage}
                    imageAcceptExtensions={"image/*"}
                />
            </Route>,
        ];

        const hotelRoutesToSelect = [
            <Route path={routes.home} exact key="home">
                <AllItems
                    title="Мои отели"
                    initAction={this.getAllItems}
                    items={this.state.AllItems}
                    loading={this.state.loading}
                    viewAction={this.getViewLink}
                    editAction={this.getEditLink}
                    setHotel={this.props.setHotel}
                    setDirectLink={this.props.setDirectLink}
                    thisManteraExport={thisManteraExport}
                />
            </Route>,
        ].concat(viewAndEditFormRoutes);

        const hotelsRoutes = [
            <Route path={routes.home} exact key="home">
                <AllItems
                    title="Список отелей"
                    addRoute={routes.add}
                    initAction={this.getAllItems}
                    items={this.state.AllItems}
                    loading={this.state.loading}
                    viewAction={this.getViewLink}
                    editAction={this.getEditLink}
                    toggleAction={this.toggleItem}
                    removeAction={this.removeItem}
                    listButtons={listButtons}
                />
            </Route>,
            <Route path={routes.add()} exact key="add">
                <AddForm
                    title={"Новый отель"}
                    loading={this.state.loading}
                    fields={fields}
                    initAction={this.initCurrentItem}
                    item={this.state.currentItem}
                    getBackLink={this.getBackLink}
                    submitAction={this.addItem}
                    fieldUpdateHandler={this.setFieldValue}
                    errorFields={this.state.error}
                />
            </Route>,
        ];

        const operatorRoutes = [
            <Route
                key="room_quotas"
                path={routes.bound(":mainId", "room_quotas")}
                render={(props) => (
                    <RoomQuotasContainer
                        hotelName={this.props?.hotelName}
                        user={this.props.user}
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["room_types", "rates_short"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                        openLeftMenu={this.props.openLeftMenu}
                    />
                )}
            ></Route>,
            <Route
                key="rates"
                path={routes.bound(":mainId", "rates")}
                render={(props) => (
                    <RatesContainer
                        hotelId={this.props.hotelId}
                        baseEntity="hotels"
                        {...props}
                        auxEntity={[
                            "payment_methods",
                            "services",
                            "room_types",
                            "service_categories",
                            "rates",
                            "market_codes",
                            "cancellation_policy",
                            "refund",
                        ]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="services"
                path={routes.bound(":mainId", "services")}
                render={(props) => (
                    <ServicesContainer
                        hotelId={this.props.hotelId}
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["service_categories"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="room_rates"
                path={routes.bound(":mainId", "room_rates")}
                render={(props) => (
                    <RoomRatesContainer
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["room_types", "rates_short"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="reservations"
                path={routes.bound(":mainId", "reservations")}
                render={(props) => (
                    <ReservationsContainer
                        baseEntity="hotels"
                        {...props}
                        fields={fields}
                        auxEntity={["room_types", "rates", "refund"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                        user={this.props.user}
                    />
                )}
            ></Route>,
            <Route
                key="reservations_asu"
                path={routes.bound(":mainId", "reservations_asu")}
                render={(props) => (
                    <ReservationsASUContainer
                        baseEntity="hotels"
                        {...props}
                        fields={fields}
                        auxEntity={["room_types", "rates", "refund"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                        user={this.props.user}
                    />
                )}
            ></Route>,
            <Route
                key="promo"
                path={routes.bound(":mainId", "promo")}
                render={(props) => (
                    <PromoContainer
                        baseEntity="hotels"
                        {...props}
                        fields={fields}
                        auxEntity={[
                            "rates",
                            "type_discount_promo",
                            "room_types",
                        ]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="banArrivals"
                path={routes.bound(":mainId", "banArrivals")}
                render={(props) => (
                    <BanArrivalsContainer
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["room_types", "rates"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="vector_prices"
                path={routes.bound(":mainId", "vector_prices")}
                render={(props) => (
                    <VectorPricesContainer
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["rates_short", "room_types"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="official"
                path={routes.bound(":mainId", "official")}
                render={(props) => (
                    <OfficialContainer baseEntity="hotels" {...props} />
                )}
            ></Route>,
            <Route
                key="period_residence"
                path={routes.bound(":mainId", "period_residence")}
                render={(props) => (
                    <PeriodResidenceContainer
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["rates_short", "room_types"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="price_explanation "
                path={routes.bound(":mainId", "price_explanation")}
                render={(props) => (
                    <PriceExplanationContainer
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["rates_short", "room_types"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="purchased_services "
                path={routes.bound(":mainId", "purchased_services")}
                render={(props) => (
                    <PurchasedServicesContainer
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["service_categories"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="subscriptions"
                path={routes.bound(":mainId", "subscriptions")}
                render={(props) => (
                    <SubscriptionContainer
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["room_types"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="price_periods"
                path={routes.bound(":mainId", "price_periods")}
                render={(props) => (
                    <PricePeriodsContainer
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["rates"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="service_categories"
                path={routes.bound(":mainId", "service_categories")}
                render={(props) => (
                    <ServiceCategoriesContainer
                        hotelId={this.props.hotelId}
                        baseEntity="hotels"
                        {...props}
                    />
                )}
            ></Route>,
            <Route
                key="room_feature_categories"
                path={routes.bound(":mainId", "room_feature_categories")}
                render={(props) => (
                    <RoomFeatureCategoriesContainer
                        hotelId={this.props.hotelId}
                        baseEntity="hotels"
                        {...props}
                    />
                )}
            ></Route>,
            <Route
                key="room_features"
                path={routes.bound(":mainId", "room_features")}
                render={(props) => (
                    <RoomFeaturesContainer
                        hotelId={this.props.hotelId}
                        baseEntity="hotels"
                        {...props}
                        auxEntity={["room_feature_categories"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
        ];

        const managerRoutes = [
            <Route
                key="room_types"
                path={routes.bound(":mainId", "room_types")}
                render={(props) => (
                    <RoomTypesContainer
                        baseEntity="hotels"
                        hotelId={this.props.hotelId}
                        {...props}
                        auxEntity={["room_features"]}
                        auxSource={this.getAllBoundItems}
                        auxData={this.state.AuxItems}
                    />
                )}
            ></Route>,
            <Route
                key="market_groups"
                path={routes.bound(":mainId", "market_groups")}
                render={(props) => (
                    <MarketGroupContainer
                        baseEntity="hotels"
                        hotelId={this.props.hotelId}
                        {...props}
                    />
                )}
            ></Route>,
            <Route
                key="market_codes"
                path={routes.bound(":mainId", "market_codes")}
                render={(props) => (
                    <MarketCodesContainer
                        baseEntity="hotels"
                        hotelId={this.props.hotelId}
                        {...props}
                    />
                )}
            ></Route>,
            <Route
                key="message_logs"
                path={routes.bound(":mainId", "message_logs")}
                render={(props) => (
                    <MessageLogsContainer
                        baseEntity="hotels"
                        hotelId={this.props.hotelId}
                        {...props}
                    />
                )}
            ></Route>,
            <Route
                key="cancellation_policy"
                path={routes.bound(":mainId", "cancellation_policy")}
                render={(props) => (
                    <CancellationPolicyContainer
                        baseEntity="hotels"
                        hotelId={this.props.hotelId}
                        {...props}
                    />
                )}
            ></Route>,
            <Route
                key="refund"
                path={routes.bound(":mainId", "refund")}
                render={(props) => (
                    <RefundContainer
                        baseEntity="hotels"
                        hotelId={this.props.hotelId}
                        {...props}
                    />
                )}
            ></Route>,
            <Route
                key="operators"
                path={routes.bound(":mainId", "users")}
                render={(props) => (
                    <UsersContainer
                        baseEntity="hotels"
                        {...props}
                        user={this.props.user}
                    />
                )}
            />,
        ]
            .concat(operatorRoutes)
            .concat(hotelRoutesToSelect);

        const adminRoutes = [
            <Route
                key="configurations"
                path={routes.bound(":mainId", "configurations")}
                render={(props) => (
                    <ConfigurationsContainer baseEntity="hotels" {...props} />
                )}
            ></Route>,
            <Route
                key="paymentMethods"
                path={routes.bound(":mainId", "payment_methods")}
                render={(props) => (
                    <PaymentMethodsContainer baseEntity="hotels" {...props} />
                )}
            ></Route>,
            <Route
                key="interface_types"
                path={routes.bound(":mainId", "interface_types")}
                render={(props) => (
                    <InterfaceTypesContainer baseEntity="hotels" {...props} />
                )}
            ></Route>,
            <Route
                key="interfaces"
                path={routes.bound(":mainId", "interfaces")}
                render={(props) => (
                    <InterfacesContainer baseEntity="hotels" {...props} />
                )}
            ></Route>,
        ]
            .concat(hotelsRoutes)
            .concat(viewAndEditFormRoutes);

        switch (userType) {
            case "operator":
                userTypeRoutes = operatorRoutes;
                break;
            case "manager_export":
            case "manager":
                userTypeRoutes = managerRoutes;
                break;
            case "admin":
                userTypeRoutes = adminRoutes;
                break;
        }
        return (
            <Switch>
                {userTypeRoutes}
                <Route render={() => <Redirect to="/" replace />} />{" "}
            </Switch>
        );
    };
}

HotelsContainer.propTypes = {
    user: PropTypes.object.isRequired,
    setHotelId: PropTypes.func,
    hotelName: PropTypes.string,
};

export default HotelsContainer;
